export default __webpack_public_path__ + "static/gitlab-ef131464e214f0df122b79e848de1b6f.png";